import { jsx as _jsx } from "react/jsx-runtime";
export default function SectionDiv({ children }) {
    const styles = {
        box: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            gap: 0
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        style: styles.box,
        children: children
    });
}
